import React from 'react';
import styled from 'styled-components';
import { formatNumber } from '../../../../helpers/number-formatters';
import { Slice } from '../../../../logic/graphql/types/types';

export const COLORS = ['#FAD28C', '#5C9A75', '#429AB2', '#98D7E9'];
export const INNER_COLORS = ['#EEBC64', '#3D855A', '#20829C', '#7AC4DA'];

export const ChartWrapper = styled.div`
  min-width: 400px;
  max-width: 500px;
`;

const Container = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  justify-content: center;
  font-size: 11px;
  @media (max-width: 1400px) {
    font-size: 10px;
  }
`;

const Circle = styled.div.attrs(() => ({})) <{ color: string }>`
  width: 24px;
  height: 24px;
  border-radius: 12px;
  background: ${(props) => props.color};
  margin-right: 10px;
  flex: none;
  @media (min-width: 768px) {
    margin-right: 20px;
  }
`;

const LabelContainer = styled.div`
  max-width: 70px;
  @media (min-width: 640px) {
    max-width: 100px;
  }
  @media (min-width: 768px) {
    max-width: unset;
  }
  @media (min-width: 1280px) {
    max-width: 100px;
  }
`;

const PercentContainer = styled.div`
  max-width: 60px;
  @media (min-width: 640px) {
    max-width: 80px;
  }
  @media (min-width: 768px) {
    max-width: unset;
  }
  @media (min-width: 1280px) {
    max-width: 60px;
  }
`;

export const Legend = (props: { sumPortfolioSlices?: Slice[] }): JSX.Element => {
  return (
    <Container>
      {props.sumPortfolioSlices?.map((s: Slice, index: number) => (
        <div key={index} className="w-1/1 flex flex-row items-center mb-3 last:mb-0">
          <Circle color={COLORS[index % COLORS.length]} />
          <LabelContainer className="flex-1">
            <span className="">
              <b>{s.name}</b>
            </span>
          </LabelContainer>
          <PercentContainer className="flex-1 flex flex-col items-end pr-2">
            <span className="text-right">
              <b>{s.percent}%</b>
            </span>
          </PercentContainer>
          <div className="flex-1 flex flex-col items-end">
            <span className="text-right nowrap">{formatNumber(s.value, 'HUF')}</span>
          </div>
        </div>
      ))}
    </Container>
  );
};
